
export default class MultipleChoiceOption {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.slug || '';
    this.display_label = data.answer_text || '';
    this.followup_question = data.followup_question || '';
    this.requires_followup = data.requires_followup || false;
  }
}
